import ReactGA from 'react-ga';
import {analyticsEnabled} from "./AppEnv";

var GAKey = 'UA-149721005-2';

export const logPageView = (pageKey) => {
    if (analyticsEnabled()) {
        ReactGA.initialize(GAKey);
        ReactGA.pageview(pageKey);
    }
};

export const logEvent = (actionName, actionCategory = 'User') => {
    if (analyticsEnabled()) {
        ReactGA.event({
            category: actionCategory,
            action: actionName
        });
    }
};
